import { isNumber, assign, get } from 'lodash';
import { defineMessages } from 'react-intl';
import { single } from 'validate.js';
import money, { Money, format } from '../../lib/money';
import {
  extractCardExpirationParts,
  expirationDateValid,
} from '../../lib/card-functions';
import Purchase from '../../lib/purchase';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  selectCard: {
    id: 'commitForm.errors.selectCard',
    defaultMessage: 'Select a credit card option',
  },
  badPassword: {
    id: 'commitForm.errors.badPassword',
    defaultMessage: 'must be at least 8 characters long',
  },
  badEmail: {
    id: 'commitForm.errors.badEmail',
    defaultMessage: 'this is not an email',
  },
  maxSlots: {
    id: 'commitForm.errors.maxSlots',
    defaultMessage: 'not enough slots remaining',
  },
  maxAmount: {
    id: 'commitForm.errors.maxAmount',
    defaultMessage: 'can\'t be more than {amount}',
  },
  minAmount: {
    id: 'commitForm.errors.minAmount',
    defaultMessage: 'can\'t be less than {amount}'
  },
  youHaveAnAccount: {
    id: 'commitForm.errors.youHaveAnAccount',
    defaultMessage: 'you already have an account, please sign in.'
  },
});

export default (values, props) => {
  const errors = { card: {}, auth: {} };

  if (!values.skip && values.card && values.card.paymentSourceId === '') {
    errors.card.paymentSourceId = formatMessage(props.intl)(i18n.selectCard);
  }

  if (!values.skip && values.card && values.card.paymentSourceId === 'new') {
    if (!values.card || !values.card.fullName) {
      errors.card.fullName = ' ';
    }
    if (!values.card || !values.card.zipCode) {
      errors.card.zipCode = ' ';
    }
    if (!values.card || !values.card.expDate) {
      errors.card.expDate = ' ';
    } else {
      const expParts = extractCardExpirationParts(values.card.expDate);
      if (!expirationDateValid(expParts)) {
        errors.card.expDate = ' ';
      }
    }
  }

  if (values.auth) {
    assign(errors, validateAuth(values, props));
  }

  if (!values.skip && values.claimedSlots) {
    assign(errors, validateClaimedSlots(values, props));
  }

  if (!values.skip && Purchase.isSpecifiedPerPerson(props.purchase.group.splitType)
    && values.allowedShareAmount) {
    assign(errors, validateAllowedShareAmount(values, props));
  }

  return errors;
};

const validateAuth = (values, props) => {
  const emailError = validateEmail(values, formatMessage(props.intl));
  if (!emailError && !values.password && !props.user && props.detectedEmail) {
    return { auth: { needToLogin: ' ' } };
  }
  if (values.auth.createGuestAccount) {
    return { auth: emailError };
  } else {
    return { auth: { ...emailError, ...validatePassword(values, formatMessage(props.intl)) } };
  }
}

const validatePassword = (values, formatMessage) => {
  const password = get(values, 'auth.password', '');
  if (password.length < 8) {
    return { password: formatMessage(i18n.badPassword) };
  }

  return {};
};

const validateEmail = (values, formatMessage) => {
  if (single(values.auth.email, { email: true, presence: true })) {
    return { email: formatMessage(i18n.badEmail) };
  }
}

const validateClaimedSlots = (values, props) => {
  const { purchase: { productOrGroupMaxSlots: maxSlots } } = props;
  const slots = maxSlots - props.otherMembersSlots - values.claimedSlots;

  if (isNumber(maxSlots) && slots < 0) {
    return { claimedSlots: formatMessage(props.intl)(i18n.maxSlots) };
  }

  return {};
};

export const validateAllowedShareAmount = (values, props) => {
  const {
    purchase: { group, maxProductCostByAmount },
  } = props;
  const minContribution = money(group.minContribution);
  const maxProductCostAmount = money(maxProductCostByAmount.amount);
  const largestAllowed = Money.max([minContribution, maxProductCostAmount]);
  const allowedShareAmount = money(values.allowedShareAmount);

  if (allowedShareAmount.isGreaterThan(largestAllowed)) {
    return {
      allowedShareAmount: formatMessage(props.intl)(i18n.maxAmount, { amount: format(largestAllowed) }),
    };
  }

  if (allowedShareAmount.isLessThan(minContribution)) {
    return {
      allowedShareAmount: formatMessage(props.intl)(i18n.minAmount, { amount: format(minContribution) }),
    };
  }

  return {};
};



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/validate.js